import { ReferenceList } from './reference-list.interface';

export const getReferenceListDescriptionByCode = (list: ReferenceList[], code: string): string => {
    const refList = list.find((type) => type.codes.includes(code));

    return refList?.description ? refList.description : '';
};
